import { get, reduce } from 'lodash';

import { DecimalNumber } from '../common/decimal-number/decimal-number';
import { TRANSFER_FORM_FIELD_PATHS } from '../services/transfer/transfer-form-field-paths';
import { calculateUnitCost } from '../services/transfer/transfer.util';
import {
  IQohInventoryItemVenue,
  ITransferFormFieldPath,
} from '../types/entities/transfer/transfer.type';

const calcTotalCost = (
  items: IQohInventoryItemVenue[],
  fieldPath: ITransferFormFieldPath = TRANSFER_FORM_FIELD_PATHS,
): DecimalNumber => {
  return reduce(
    items,
    (totalCost, currentItem) => {
      const itemInitialCount = new DecimalNumber(
        get(currentItem, fieldPath.initialCount, 0),
      );
      const itemUnitCost = calculateUnitCost({ data: currentItem });

      return totalCost.add(itemInitialCount.mul(itemUnitCost));
    },
    new DecimalNumber(0),
  );
};

export { calcTotalCost };
